import { ModalWrapper } from "src/utils/fw"

export const OnDemandBlock = ({children}) => <ModalWrapper wrapperStyle={{backgroundColor: "#3c1d4a", color: "white"}}>
    <p>Congress is now closed – thank you for joining us.</p> 
    <p>Please explore our Exhibition Hall, ISF Exploration Zone and Speaker Gallery, the Sponsor Theatre, and the On-Demand page to watch recorded sessions.</p>
    <p>The platform will remain open until 19 November.</p>
</ModalWrapper>